import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const retailerCollectionsFlyersAccessControl: DomainAccessControlConfig = {
  permissions: [
    Permission.Flyers,
    Permission.CatalogProductsView,
    Permission.StoreConfigsView,
    Permission.RetailerCollectionsView,
  ],
}

export const flyerPageEditAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.FlyersModify, Permission.Flyers, Permission.RetailerCollectionsView],
    warehouseFeatureToggles: [FeatureToggle.flyerPageManagement],
  },
  {
    permissions: [Permission.FlyersModify, Permission.Flyers, Permission.RetailerCollectionsView],
    featureToggles: [FeatureToggle.flyerPageManagement],
    restrictedBannersAllowed: true,
  },
]

export const flyerPageBuilderAccessControl: DomainAccessControlConfig = [
  {
    permissions: [
      Permission.Flyers,
      Permission.CatalogProductsView,
      Permission.StoreConfigsView,
      Permission.RetailerCollectionsView,
    ],
    warehouseFeatureToggles: [FeatureToggle.retailerCreateDigitalFlyerEnabled],
  },
  {
    permissions: [
      Permission.Flyers,
      Permission.CatalogProductsView,
      Permission.StoreConfigsView,
      Permission.RetailerCollectionsView,
    ],
    featureToggles: [FeatureToggle.retailerCreateDigitalFlyerEnabled],
    restrictedBannersAllowed: true,
  },
]

export const retailerCollectionsDigitalFlyersAccessControl: DomainAccessControlConfig = [
  {
    permissions: [
      Permission.Flyers,
      Permission.CatalogProductsView,
      Permission.StoreConfigsView,
      Permission.RetailerCollectionsView,
    ],
    warehouseFeatureToggles: [FeatureToggle.retailerCreateDigitalFlyerEnabled],
  },
  {
    permissions: [
      Permission.Flyers,
      Permission.CatalogProductsView,
      Permission.StoreConfigsView,
      Permission.RetailerCollectionsView,
    ],
    featureToggles: [FeatureToggle.retailerCreateDigitalFlyerEnabled],
    restrictedBannersAllowed: true,
  },
]
